export default {
  GET_LIST: '/manage/inci/basfMark/findList',
  UPDATE_INCI: '/manage/inci/basfMark/update',
  UPLOAD: '/manage/inci/basfMark/upload',
  DOWNLOAD: '/auth/public/download_file'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/inciBasfMark.js